const mLogin = {
  mLogin: {
    alerts: {
      handleAuthentication: {
        error: 'Los datos ingresados son incorrectos.'
      }
    },

    buttonPrimary: 'ACCEDER',

    forgetPassword: '¿Olvidaste tu contraseña? Recuperar',

    inputs: {
      contraseña: {
        placeholder: 'Contraseña'
      },

      usuario: {
        placeholder: 'Usuario'
      }
    },

    message: 'Espera un momento...',

    validation: {
      email: {
        email: 'El email ingresado no es una cuenta válida.',
        required: 'El usuario es requerido.'
      },

      password: {
        required: 'La contraseña es requerida.'
      }
    }
  }
}

export default mLogin
